<template>
	<div class="base_info_card">
		<slot></slot>
		<p class="id_card" v-for="(item,index) in list" :key="index"
			><span>{{item.label}}</span
			>{{ item.value || '--' }}</p
		>
	</div>
</template>
<script>
export default {
    name: 'formHeader',
    props: {
        list: {
            type: Array,
            default: () => []
        },
    }
}
</script>
<style lang="less" scoped>
.base_info_card {
	box-sizing: border-box;
	border-radius: 20px;
	overflow: hidden;
	color: #fff;
	padding: 40px;
	background-size: 100% auto;
	background-position: bottom;
	background-repeat: no-repeat;
	background-image: url('../../../assets/img/patient_info_card_back.png');
	.id_card {
		margin-bottom: 28px;
	}
	.id_card:last-child {
		margin-bottom: 0;
	}
	> p {
		font-family: PingFangSC-Regular;
		height: 34px;
		line-height: 34px;
		font-size: 28px;
		font-weight: normal;
		line-height: 34px;
		span {
			color: rgba(255, 255, 255, 0.8);
		}
	}
}
</style>